module.exports = __webpack_public_path__ + "static/media/slack.04753969.png";